/* hoshiami お気に入り（カラー単位）
 * ------------------------------------------------------------------
 * 保存するのはカラー（バリエーション）。お客様アカウントの metafield hoshiami.wishlist_variants を
 * App Proxy（/apps/hoshiami/wishlist/add|remove、body {variant_id}）→ hoshiami ERP が更新する。
 * ・商品ページ [data-hw-btn]：いま選んでいるカラーを保存／解除。カラーを切り替えるとボタンの状態も切り替わる
 * ・お気に入りページ [data-hw-remove]：その行を削除 / [data-hw-cart]：そのカラーをそのままカートへ（テーマのカートドロワーを更新して開く）
 * ・未ログイン: ログイン案内モーダル（保存はしない）
 * ・409 wishlist_full: 「最大 100 件」のお知らせ
 * 設定は snippets/hoshiami-wishlist-config.liquid が window.hoshiamiWishlist に入れる。
 */
(function () {
  if (window.__hoshiamiWishlistInit) return;
  window.__hoshiamiWishlistInit = true;
  var cfg = window.hoshiamiWishlist || {};
  var ids = new Set((cfg.ids || []).filter(function (x) { return x !== undefined && x !== null && x !== ''; }).map(String));
  var busy = new Set();
  var MAX = cfg.max || 100;

  function idOf(gidOrId) {
    var m = String(gidOrId).match(/(\d+)\s*$/);
    return m ? m[1] : String(gidOrId);
  }

  /* ---- 商品ページのボタン ---- */
  function paint(btn) {
    var on = ids.has(String(btn.getAttribute('data-variant-id')));
    btn.classList.toggle('is-on', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var lbl = btn.querySelector('[data-hw-label]');
    if (lbl) lbl.textContent = on ? 'お気に入り済み' : 'お気に入りに追加';
  }

  function paintAll() {
    document.querySelectorAll('[data-hw-btn]').forEach(paint);
    var c = document.querySelector('[data-hw-count]');
    if (c) {
      c.hidden = ids.size === 0;
      var s = c.querySelector('span');
      if (s) s.textContent = ids.size < 100 ? String(ids.size) : '99+';
    }
    var pc = document.querySelector('[data-hw-pagecount]');
    if (pc) pc.textContent = ids.size + ' 件（最大 ' + MAX + ' 件）';
  }

  function setVariant(id) {
    if (!id) return;
    document.querySelectorAll('[data-hw-btn]').forEach(function (b) {
      if (b.getAttribute('data-variant-id') !== String(id)) {
        b.setAttribute('data-variant-id', String(id));
        paint(b);
      }
    });
  }

  // Dawn：カラー切り替え時に variant-change が発行される
  function hookVariantChange() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
        var v = evt && evt.data && evt.data.variant;
        if (v && v.id) setVariant(v.id);
      });
    }
    // 念のため：購入フォームの id が変わったら追随
    document.addEventListener('change', function () {
      setTimeout(function () {
        var inp = document.querySelector('product-form form input[name="id"]');
        if (inp && inp.value) setVariant(inp.value);
      }, 60);
    });
  }

  /* ---- トースト ---- */
  var toastEl, toastTimer;
  function toast(msg, link) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'hw-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    if (link) {
      var a = document.createElement('a');
      a.href = link.href;
      a.textContent = link.text;
      a.className = 'hw-toast__link';
      toastEl.appendChild(a);
    }
    toastEl.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-show'); }, 3200);
  }

  /* ---- ログイン案内モーダル ---- */
  var modal;
  function withReturn(url) {
    if (!url) return '#';
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'return_url=' + encodeURIComponent(location.pathname + location.search);
  }
  function openLogin() {
    if (!modal) {
      modal = document.createElement('div');
      modal.className = 'hw-modal';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-labelledby', 'hw-modal-title');
      modal.innerHTML =
        '<div class="hw-modal__box">' +
        '<button type="button" class="hw-modal__close" data-hw-close aria-label="閉じる">×</button>' +
        '<div class="hw-modal__icon"><svg viewBox="0 0 24 24" width="36" height="36" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.3-9.2C1.4 8 3.4 4.5 7 4.5c2 0 3.4 1.1 5 3 1.6-1.9 3-3 5-3 3.6 0 5.6 3.5 4.3 6.8-1.8 4.6-9.3 9.2-9.3 9.2z"/></svg></div>' +
        '<p class="hw-modal__title" id="hw-modal-title">お気に入りに保存するにはログインが必要です</p>' +
        '<p class="hw-modal__text">ログインすると、お気に入りはご自身のアカウントに保存され、別の端末からも見られます。</p>' +
        '<a class="hw-modal__btn" data-hw-login href="#">ログイン</a>' +
        '<a class="hw-modal__link" data-hw-register href="#">はじめての方はこちら（新規登録）</a>' +
        '</div>';
      modal.addEventListener('click', function (e) {
        if (e.target === modal || e.target.closest('[data-hw-close]')) modal.hidden = true;
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal && !modal.hidden) modal.hidden = true;
      });
      document.body.appendChild(modal);
    }
    modal.querySelector('[data-hw-login]').setAttribute('href', withReturn(cfg.loginUrl));
    modal.querySelector('[data-hw-register]').setAttribute('href', withReturn(cfg.registerUrl));
    modal.hidden = false;
    var b = modal.querySelector('[data-hw-login]');
    if (b) b.focus();
  }

  /* ---- 通信 ---- */
  function call(action, vid) {
    return fetch((cfg.proxy || '/apps/hoshiami/wishlist') + '/' + action, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ variant_id: String(vid) })
    }).then(function (r) {
      return r.json().catch(function () { return null; }).then(function (j) { return { status: r.status, body: j }; });
    });
  }

  function errorCode(res) {
    var d = res && res.body && res.body.detail;
    return d && typeof d === 'object' && d.error ? d.error : '';
  }

  function handleError(res) {
    var code = errorCode(res);
    if (res.status === 401 && code === 'login_required') { cfg.loggedIn = false; openLogin(); return; }
    if (res.status === 409 && code === 'wishlist_full') { toast('お気に入りは最大 ' + MAX + ' 件までです。不要なものを外してからお試しください。'); return; }
    toast('保存できませんでした。時間をおいてもう一度お試しください。');
  }

  function applyItems(items) {
    ids = new Set((items || []).map(idOf));
    paintAll();
  }

  function removeRow(vid) {
    var li = document.querySelector('[data-hw-item="' + vid + '"]');
    if (!li) return;
    li.classList.add('is-leaving');
    setTimeout(function () {
      li.remove();
      var list = document.querySelector('[data-hw-list]');
      var empty = document.querySelector('[data-hw-empty]');
      if (list && empty && !list.querySelector('[data-hw-item]')) {
        list.hidden = true;
        empty.hidden = false;
      }
    }, 220);
  }

  function toggle(btn, vid, action) {
    if (busy.has(vid)) return;
    busy.add(vid);
    btn.classList.add('is-busy');
    call(action, vid).then(function (res) {
      if (res.status === 200 && res.body && Array.isArray(res.body.items)) {
        applyItems(res.body.items);
        if (action === 'remove' && document.querySelector('[data-hw-page]')) removeRow(vid);
        else toast(action === 'add' ? 'お気に入りに追加しました' : 'お気に入りから削除しました', action === 'add' ? { href: cfg.pageUrl, text: '一覧を見る' } : null);
      } else {
        handleError(res);
      }
    }).catch(function () {
      toast('保存できませんでした。通信環境をご確認ください。');
    }).then(function () {
      busy.delete(vid);
      btn.classList.remove('is-busy');
    });
  }

  /* ---- カートに追加（お気に入りページ） ---- */
  function refreshCartBubble() {
    var url = (cfg.rootUrl || '/') + '?sections=cart-icon-bubble';
    return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
      var html = j && j['cart-icon-bubble'];
      var target = document.getElementById('cart-icon-bubble');
      if (!html || !target) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var src = doc.querySelector('.shopify-section') || doc.body;
      target.innerHTML = src.innerHTML;
    }).catch(function () {});
  }

  // テーマの「カートに追加する」と同じ動き：カートドロワー（または通知）の中身を差し替えて開く
  function themeCart() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function addToCart(btn, vid) {
    if (busy.has('cart:' + vid)) return;
    busy.add('cart:' + vid);
    btn.classList.add('is-busy');
    var cart = themeCart();
    var canRender = cart && typeof cart.renderContents === 'function' && typeof cart.getSectionsToRender === 'function';
    var body = { id: Number(vid), quantity: 1 };
    if (canRender) {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(btn);
    }
    fetch((cfg.cartAddUrl || '/cart/add') + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return null; }).then(function (j) {
        if (!r.ok || !j || j.status) {
          toast((j && (j.description || j.message)) || 'カートに追加できませんでした。');
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hoshiami-wishlist', productVariantId: String(vid), cartData: j });
        }
        if (canRender && j.sections) {
          try {
            cart.classList.remove('is-empty');
            cart.renderContents(j);
            return;
          } catch (e) { /* 失敗したら下のトースト + 角標更新にフォールバック */ }
        }
        toast('カートに追加しました', { href: cfg.cartUrl || '/cart', text: 'カートを見る' });
        return refreshCartBubble();
      });
    }).catch(function () {
      toast('カートに追加できませんでした。通信環境をご確認ください。');
    }).then(function () {
      busy.delete('cart:' + vid);
      btn.classList.remove('is-busy');
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-hw-btn],[data-hw-remove],[data-hw-cart]');
    if (!t) return;
    e.preventDefault();
    e.stopPropagation();
    if (t.hasAttribute('data-hw-cart')) { addToCart(t, t.getAttribute('data-hw-cart')); return; }
    if (!cfg.loggedIn) { openLogin(); return; }
    if (t.hasAttribute('data-hw-remove')) { toggle(t, t.getAttribute('data-hw-remove'), 'remove'); return; }
    var vid = String(t.getAttribute('data-variant-id'));
    toggle(t, vid, ids.has(vid) ? 'remove' : 'add');
  }, true);

  function start() {
    paintAll();
    hookVariantChange();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
